import { all } from 'redux-saga/effects';

import manageTeamSaga from './send-invite-saga';

export default function* rootSaga(action) {
	yield all([manageTeamSaga(action)]);
}
